<template>
  <div class="kw_label_col">
    <div v-for="(item,index) in value.childPageJsonArr[0].fieldSet[0].childPageJsonArr" :key="index">
      <kw_tabs v-model="current" scroll @change="clickTab">
        <kw_tab :name="item.defaultIdStr" :title="item.fieldSet[0].defaultValStr"></kw_tab>
        <kw_tab v-for="(twoItem,twoIndex) in value.childPageJsonArr[1].fieldSet[0].childPageJsonArr" :key="twoIndex" :name="twoItem.defaultIdStr" :title="twoItem.fieldSet[0].defaultValStr"
          v-if="(item.defaultIdStr == twoItem.fieldSet[1].defaultValStr)"
        ></kw_tab>
      </kw_tabs>
    </div>
  </div>
</template>

<script>
// kw_tabs 标签组组件
import kw_tabs from '@/components/kw/kw_tabs.vue';
// kw_tab 标签组件
import kw_tab from '@/components/kw/kw_tab.vue';

import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_label_col',
  props: {
    value: {
      type: Object,
      value: {}
    }
  },
  data() {
    return {
      current:null
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    kw_tabs,
    kw_tab
  },
  methods: {
    /**
     * 点击时 进行关联的页面打开
     */
    clickTab(tab, event){
      var clickVal = tab.name;
      var styleSet = this.data.value.styleSet;
      // console.log("clickVal================", clickVal, styleSet);
      var jumpJson = {
        pageId: styleSet.clickPageId,
        tableId: styleSet.clickTableId,
        mainId: clickVal,
        callBackType: 1
      };
      pageUtils.toNewLookPage(this,jumpJson);
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
